import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import { PdfFlipbook } from './lib'
// import logo from './logo.svg';
import './App.css';

function App() {
// const [seturl] = useState("");
//const id = props.match.params.book;
const id = new URLSearchParams(window.location.search).get("book");
const lang = new URLSearchParams(window.location.search).get("language");
const readingId = new URLSearchParams(window.location.search).get("reading");
const bookId = new URLSearchParams(window.location.search).get("bookId");
const [loading, setLoading] = useState(false);
// const [ids,setids] = useState(id);
// const [langs,setlang] = useState(lang);
const [ids] = useState(id);
const [langs] = useState(lang);

const readingRecord = (formData) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`https://api.joyread.club/reading/record`, formData)
			.then((res) => {
				if (res.data.code !== 200) throw res.data;
				resolve(res.data);
			})
			.catch((err) => {
				reject(err);
			});
	})
}

// PDF 容器 ref
const pdfContainerRef = useRef(null);
const uatUrl = 'https://joyread.club';

useEffect(() => {
	if (!id) {
		window.location.href = uatUrl;
		return;
	}

	window.history.pushState("","","https://pdf.joyread.club");
	// window.history.pushState("","","http://127.0.0.1:3000");
	setLoading(true);

	let recordTimer = null; // 阅读记录定时器
	let checkTimer = null;
    let lastActiveTime = Date.now();
    const LIMIT = 30 * 60 * 1000; // 30分钟

	// ========== ✅ 阅读上报逻辑（仅 readingId 存在时启用） ==========
	if (readingId) {
      const formData = new FormData();
      formData.append("reading_id", readingId);
	  recordTimer && clearInterval(recordTimer);
      // 定时上报阅读记录
      recordTimer = setInterval(() => {
        readingRecord(formData)
          .then((res) =>
            console.log("Reading record updated successfully:", res)
          )
          .catch((err) =>
            console.error("Error updating reading record:", err)
          );
      }, 120000); // 每2分钟
    }

	// ========== 自动退出逻辑 ==========
    const logoutToHome = () => {
      console.log("超时未操作，退出阅读页。");
      if (readingId) {
        const exitForm = new FormData();
        exitForm.append("reading_id", readingId);
        navigator.sendBeacon(
          "https://api.joyread.club/reading/return",
          exitForm
        );
      }
	  if (readingId) {
		window.location.href = uatUrl + '/book/' + bookId;
	  } else {
		window.location.href = uatUrl;
	  }
    };

    const updateLastActive = () => {
      lastActiveTime = Date.now();
	  console.log('sss', lastActiveTime)
    };

    // 定期检测是否超时（每分钟检查一次）
    checkTimer = setInterval(() => {
      const now = Date.now();
      if (now - lastActiveTime > LIMIT) {
        logoutToHome();
      }
    }, 60000);

    // 用户活动事件更新 lastActiveTime
    const activityEvents = ["pointermove", "pointerdown", "keydown", "scroll", "click", "touchstart", "touchmove"];
    activityEvents.forEach((e) =>
      window.addEventListener(e, updateLastActive, { passive: true })
    );

	// 监听可见性变化（切标签页）
    const handleVisibilityChange = () => {
      updateLastActive();
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

	// ===== 注入 iframe 内部事件（前提：iframe 同源） =====
    const tryInjectIframeEvents = () => {
      if (!pdfContainerRef.current) return;
      const iframe = pdfContainerRef.current.querySelector("iframe");
      if (!iframe) return;

      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        activityEvents.forEach(evt => doc.addEventListener(evt, updateLastActive, { passive: true }));
      } catch (e) {
        console.warn("无法访问 iframe，可能是跨域：", e);
      }
    };

    // 延迟一会儿，确保 iframe 渲染完成
    const injectTimer = setTimeout(tryInjectIframeEvents, 1000);


    // 页面关闭上报退出
    const handleUnload = () => {
      if (readingId) {
        const formData = new FormData();
        formData.append("reading_id", readingId);
        navigator.sendBeacon(
          "https://api.joyread.club/reading/return",
          formData
        );
      }
    };
    window.addEventListener("beforeunload", handleUnload);

    return () => {
      if (recordTimer) clearInterval(recordTimer);
      if (checkTimer) clearInterval(checkTimer);
      activityEvents.forEach((e) =>
        window.removeEventListener(e, updateLastActive)
      );
	  document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleUnload);
    };



		// let timer = null;
		// let idleTimer = null; // 用户30分钟无操作计时
    	// const INACTIVE_LIMIT = 30 * 60 * 1000; // 30分钟
		// if (id) {
		// 	//setids(id);
		// 	//setlang(lang);
		// 	// window.history.pushState("","","http://122.248.233.120:3000");
		// 	window.history.pushState("","","http://127.0.0.1:3000");
		// 	setLoading(true);

		// 	if (readingId) {
		// 		const formData = new FormData();
		// 		formData.append("reading_id", readingId);
		// 		timer && clearInterval(timer);
		// 		timer = setInterval(() => {
		// 			readingRecord(formData)
		// 			.then((res) => {
		// 				console.log("Reading record updated successfully:", res);
		// 			})
		// 			.catch((err) => {
		// 				console.error("Error updating reading record:", err);
		// 			});
		// 		}, 120000) // 2 minutes

		// 		// document.addEventListener('visibilitychange', () => {
		// 		// 	if (document.visibilityState === 'hidden') {
		// 		// 		// 页面不可见时发送退出请求
		// 		// 		console.log("Page hidden, sending exit request...");	
		// 		// 	}
		// 		// });

		// 		// 页面关闭或刷新时调用退出接口
		// 		const handleUnload = () => {
		// 		// 发送退出请求（同步请求防止被浏览器忽略）
		// 		const formData = new FormData();
		// 		formData.append("reading_id", readingId);
		// 		navigator.sendBeacon('https://api.joyread.club/reading/return', formData); // 更可靠的退出时请求方式
		// 		};

		// 		window.addEventListener('beforeunload', handleUnload);

		// 		return () => {
		// 			if (timer) clearInterval(timer);
		// 			window.removeEventListener('beforeunload', handleUnload);
		// 		};
		// 	}
		// }
		// else{
		// 	window.location.href="http://122.248.233.120:81";
		// }

		
}, []);

  return loading ? (
    <div className="App" ref={pdfContainerRef}>
		<PdfFlipbook url={ids} lang={langs}/>
    </div>
  ):null;
}
export default App;
